import i18n from '@/plugins/i18n';
import { K8_NAVTABS } from '@/utils/templates/k8mTemplate/k8m.constants';

const K8Routes = Object.freeze({
  nodes: 'k8mNodesTable',
  namespaces: 'k8mNamespacesTable',
  deployments: 'k8mDeployementsTable',
  statefulsets: 'k8mStatefulsetsTable',
  daemonsets: 'k8mDaemonsetsTable',
  pods: 'k8mPodsTable',
});

const K8NodesTags = [
  {
    label: i18n.global.t('k8.cluster'),
    metricName: 'cluster',
    value: '',
    meta: 'currentCluster',
  },
  {
    label: i18n.global.t('k8.ipAddress'),
    metricName: 'ip_address',
    value: '',
    meta: 'metaProperty3',
  },
  {
    label: i18n.global.t('k8.kubeletVersion'),
    metricName: 'kubelet_version',
    value: '',
    meta: 'metaProperty4',
  },
];

const K8DeploymentTags = [
  {
    label: i18n.global.t('k8.namespace'),
    metricName: 'namespace',
    value: '',
    meta: 'metaProperty1',
  },
  {
    label: i18n.global.t('k8.cluster'),
    metricName: 'cluster',
    value: '',
    meta: 'currentCluster',
  },
];

const K8PodTags = [
  {
    label: i18n.global.t('k8.namespace'),
    metricName: 'namespace',
    value: '',
    meta: 'metaProperty1',
  },
  {
    label: i18n.global.t('k8.cluster'),
    metricName: 'cluster',
    value: '',
    meta: 'currentCluster',
  },
  {
    label: i18n.global.t('k8.node'),
    metricName: 'node',
    value: '',
    meta: 'metaProperty4',
  },
  {
    label: i18n.global.t('k8.type'),
    metricName: 'type',
    value: '',
    meta: 'metaProperty2',
  },
  {
    label: i18n.global.t('k8.typeName'),
    metricName: 'typeName',
    value: '',
    meta: 'metaProperty3',
  },
  {
    label: i18n.global.t('k8.ipAddress'),
    metricName: 'ip_address',
    value: '',
    meta: 'metaProperty6',
  },
];

const K8NodesMetrics = [
  {
    metricName: 'k8s_node_v2_cpu_cores_allocatable',
    className: 'bg-dark-black info-cards',
    textTitle: i18n.global.t('k8.allocatableCpuCores'),
    textValColor: 'white',
    textValue: '0',
  },
  {
    metricName: 'k8s_node_v2_cpu_usage',
    className: 'bg-dark-black info-cards',
    textTitle: i18n.global.t('k8.cpuUsage'),
    textValColor: 'white',
    textValue: '0',
    type: 'compare',
  },
  {
    metricName: 'k8s_node_v2_memory_allocatable',
    className: 'bg-dark-black info-cards',
    textTitle: i18n.global.t('k8.allocMemPer'),
    textValColor: 'white',
    textValue: '0',
    format: true,
  },
  {
    metricName: 'k8s_node_v2_memory_usage',
    className: 'bg-dark-black info-cards',
    textTitle: i18n.global.t('k8.memoryUsage'),
    textValColor: 'white',
    textValue: '0',
    type: 'compare',
  },
  {
    metricName: 'k8s_node_v2_ephemeral_storage_allocatable',
    className: 'bg-dark-black info-cards',
    textTitle: i18n.global.t('k8.allocEphStorage'),
    textValColor: 'white',
    textValue: '0',
    format: true,
  },
  {
    metricName: 'k8s_node_v2_fs_usage',
    className: 'bg-dark-black info-cards',
    textTitle: i18n.global.t('k8.fsUsage'),
    textValColor: 'white',
    textValue: '0',
    type: 'compare',
  },
  {
    metricName: 'k8s_node_v2_node_unscheduled',
    className: 'bg-dark-black info-cards',
    textTitle: i18n.global.t('k8.schedulable'),
    textValColor: 'white',
    textValue: '1',
    type: 'tagText',
  },
  {
    metricName: 'k8s_node_v2_max_pods',
    className: 'bg-dark-black info-cards',
    textTitle: i18n.global.t('k8.maxPods'),
    textValColor: 'white',
    textValue: '0',
  },
];

const K8DeploymentMetrics = [
  {
    metricName: 'k8s_deployment_v2_pods_total',
    className: 'bg-dark-black info-cards',
    textTitle: i18n.global.t('k8.totalPods'),
    textValColor: 'white',
    textValue: '0',
  },
  {
    metricName: 'k8s_deployment_v2_pods_available',
    className: 'bg-dark-black info-cards',
    textTitle: i18n.global.t('k8.availablePods'),
    textValColor: 'white',
    textValue: '0',
    type: 'tagReverse',
  },
  {
    metricName: 'k8s_deployment_v2_pods_unavailable',
    className: 'bg-dark-black info-cards',
    textTitle: i18n.global.t('k8.unavailablePods'),
    textValColor: 'white',
    textValue: '0',
    type: 'tag',
  },
  {
    metricName: 'k8s_deployment_v2_pods_updated',
    className: 'bg-dark-black info-cards',
    textTitle: i18n.global.t('k8.updatedPods'),
    textValColor: 'white',
    textValue: '0',
  },
];

const K8DaemonsetMetrics = [
  {
    metricName: 'k8s_daemonset_v2_pods_total',
    className: 'bg-dark-black info-cards',
    textTitle: i18n.global.t('k8.totalPods'),
    textValColor: 'white',
    textValue: '0',
  },
  {
    metricName: 'k8s_daemonset_v2_pods_available',
    className: 'bg-dark-black info-cards',
    textTitle: i18n.global.t('k8.availablePods'),
    textValColor: 'white',
    textValue: '0',
    type: 'tagReverse',
  },
  {
    metricName: 'k8s_daemonset_v2_pods_unavailable',
    className: 'bg-dark-black info-cards',
    textTitle: i18n.global.t('k8.unavailablePods'),
    textValColor: 'white',
    textValue: '0',
    type: 'tag',
  },
  {
    metricName: 'k8s_daemonset_v2_pods_updated',
    className: 'bg-dark-black info-cards',
    textTitle: i18n.global.t('k8.updatedPods'),
    textValColor: 'white',
    textValue: '0',
  },
];

const K8StatefulsetMetrics = [
  {
    metricName: 'k8s_statefulset_v2_pods_total',
    className: 'bg-dark-black info-cards',
    textTitle: i18n.global.t('k8.totalPods'),
    textValColor: 'white',
    textValue: '0',
  },
  {
    metricName: 'k8s_statefulset_v2_pods_available',
    className: 'bg-dark-black info-cards',
    textTitle: i18n.global.t('k8.availablePods'),
    textValColor: 'white',
    textValue: '0',
    type: 'tagReverse',
  },
  {
    metricName: 'k8s_statefulset_v2_pods_unavailable',
    className: 'bg-dark-black info-cards',
    textTitle: i18n.global.t('k8.unavailablePods'),
    textValColor: 'white',
    textValue: '0',
    type: 'tag',
  },
  {
    metricName: 'k8s_statefulset_v2_pods_updated',
    className: 'bg-dark-black info-cards',
    textTitle: i18n.global.t('k8.updatedPods'),
    textValColor: 'white',
    textValue: '0',
  },
];

const K8PodsMetrics = [
  {
    metricName: 'k8s_pods_v2_status_ready',
    className: 'bg-dark-black info-cards',
    textTitle: i18n.global.t('k8.isReady'),
    textValColor: 'poor',
    textValue: 'Not ready',
    type: 'tag',
  },
  {
    metricName: 'k8s_pods_v2_status_scheduled',
    className: 'bg-dark-black info-cards',
    textTitle: i18n.global.t('k8.isScheduled'),
    textValColor: 'poor',
    textValue: 'Not scheduled',
    type: 'tag',
  },
  {
    metricName: 'k8s_pods_v2_status_terminated',
    className: 'bg-dark-black info-cards',
    textTitle: i18n.global.t('k8.status'),
    textValColor: 'poor',
    textValue: 'Terminated',
    type: 'tag',
  },
  {
    metricName: 'k8s_pods_v2_restarts_total',
    className: 'bg-dark-black info-cards',
    textTitle: i18n.global.t('k8.totalRestarts'),
    textValColor: 'white',
    textValue: '0',
  },
];

const K8RoutesConfig = [
  {
    name: 'k8mNodesTable',
    path: '/nodes',
    breadcrumbName: 'Nodes',
    tab: 'nodes',
  },
  {
    name: 'k8mNamespacesTable',
    path: '/namespaces',
    breadcrumbName: 'Namespaces',
    tab: 'namespaces',
  },
  {
    name: 'k8mDeployementsTable',
    path: '/deployments',
    breadcrumbName: 'Deployments',
    tab: 'deployments',
  },
  {
    name: 'k8mStatefulsetsTable',
    path: '/statefulsets',
    breadcrumbName: 'Statefulsets',
    tab: 'statefulsets',
  },
  {
    name: 'k8mDaemonsetsTable',
    path: '/daemonsets',
    breadcrumbName: 'Daemonsets',
    tab: 'daemonsets',
  },
  {
    name: 'k8mPodsTable',
    path: '/pods',
    breadcrumbName: 'Pods',
    tab: 'pods',
  },
];

const K8BreadcrumbNames = Object.freeze({
  cluster: 'Cluster',
  nodes: 'Nodes',
  namespaces: 'Namespaces',
  deployments: 'Deployments',
  statefulsets: 'Statefulsets',
  daemonsets: 'Daemonsets',
  pods: 'Pods',
});

const HeaderKeyMapping = [
  'k8s_node_v2_status',
  'k8s_deployment_v2_status',
  'k8s_pods_v2_status',
  'k8s_namespace_v2_namespace_status',
  'k8s_node_v2_cpu_usage',
  'k8s_node_v2_memory_usage',
  'k8s_node_v2_fs_usage',
  'k8s_deployment_v2_pods_available',
  'k8s_deployment_v2_pods_unavailable',
  'k8s_daemonset_v2_pods_available',
  'k8s_daemonset_v2_pods_unavailable',
  'k8s_statefulset_v2_pods_available',
  'k8s_statefulset_v2_pods_unavailable',
];

const K8MutationType = {
  [K8_NAVTABS.K8M_NODE_TAB]: 'currentNode',
  [K8_NAVTABS.K8M_DEP_TAB]: 'currentDep',
  [K8_NAVTABS.K8M_STAT_TAB]: 'currentStatefulset',
  [K8_NAVTABS.K8M_DAEMON_TAB]: 'currentDaemonset',
  [K8_NAVTABS.K8M_POD_TAB]: 'currentPod',
  [K8_NAVTABS.K8M_NAMESPACE_TAB]: 'currentNamespace',
  [K8_NAVTABS.K8M_CLUSTER_TAB]: 'currentCluster',
};

const K8SetMutationType = {
  [K8_NAVTABS.K8M_DEP_TAB]: 'setDeps',
  [K8_NAVTABS.K8M_STAT_TAB]: 'setStatefulsets',
  [K8_NAVTABS.K8M_DAEMON_TAB]: 'setDaemonsets',
  [K8_NAVTABS.K8M_NAMESPACE_TAB]: 'setNamespaces',
};

const K8SetCurrentMutationType = {
  [K8_NAVTABS.K8M_DEP_TAB]: 'setCurrentDep',
  [K8_NAVTABS.K8M_STAT_TAB]: 'setCurrentStateful',
  [K8_NAVTABS.K8M_DAEMON_TAB]: 'setCurrentDaemon',
};

const WorkloadList = [
  {
    key: 'all',
    label: 'All',
  },
  {
    key: K8_NAVTABS.K8M_DEP_TAB,
    label: 'Deployment',
  },
  {
    key: K8_NAVTABS.K8M_STAT_TAB,
    label: 'StatefulSet',
  },
  {
    key: K8_NAVTABS.K8M_DAEMON_TAB,
    label: 'DaemonSet',
  },
  {
    key: 'NONE',
    label: 'Others',
  },
];

const WorkloadMapping = {
  [K8_NAVTABS.K8M_DEP_TAB]: 'Deployment',
  [K8_NAVTABS.K8M_STAT_TAB]: 'StatefulSet',
  [K8_NAVTABS.K8M_DAEMON_TAB]: 'DaemonSet',
};

const WorkloadPlaceholderList = {
  [K8_NAVTABS.K8M_DEP_TAB]: i18n.global.t('k8.deployment'),
  [K8_NAVTABS.K8M_STAT_TAB]: i18n.global.t('k8.statefulset'),
  [K8_NAVTABS.K8M_DAEMON_TAB]: i18n.global.t('k8.daemonset'),
};

const StatusType = {
  ACTIVE_LIST: ['Ready', 'Available', 'Succeeded', 'Running', 'Active'],
  INACTIVE_LIST: [
    'Terminating',
    'Not ready',
    'Failed',
    'Pending',
    'Not available',
  ],
};

const CustomClassType = {
  GOOD: 'good',
  POOR: 'poor',
  TANGERINE: 'tangerine',
};

const IconNames = {
  WARN: 'info',
  GOOD: 'good',
  NORMAL: 'normal',
};

const InstanceType = {
  [K8_NAVTABS.K8M_DEP_TAB]: 'K8S_DEPLOYMENT',
  [K8_NAVTABS.K8M_STAT_TAB]: 'K8S_STATEFULSET',
  [K8_NAVTABS.K8M_DAEMON_TAB]: 'K8S_DAEMON_SET',
  [K8_NAVTABS.K8M_NAMESPACE_TAB]: 'K8S_NAMESPACE',
  [K8_NAVTABS.K8M_POD_TAB]: 'K8S_POD',
  [K8_NAVTABS.K8M_NODE_TAB]: 'K8S_NODE',
  [K8_NAVTABS.K8M_CLUSTER_TAB]: 'K8S_CLUSTER',
};

const HideNamespaceList = [
  K8_NAVTABS.K8M_CLUSTER_TAB,
  K8_NAVTABS.K8M_NAMESPACE_TAB,
  K8_NAVTABS.K8M_NODE_TAB,
];

const InstanceTabMapping = {
  K8S_DEPLOYMENT: [K8_NAVTABS.K8M_DEP_TAB],
  K8S_STATEFULSET: [K8_NAVTABS.K8M_STAT_TAB],
  K8S_DAEMON_SET: [K8_NAVTABS.K8M_DAEMON_TAB],
  K8S_NAMESPACE: [K8_NAVTABS.K8M_NAMESPACE_TAB],
  K8S_POD: [K8_NAVTABS.K8M_POD_TAB],
  K8S_NODE: [K8_NAVTABS.K8M_NODE_TAB],
};

const headerKeyType = {
  METRIC: 'metrics',
  LABELED_METRICS: 'labeledMetric',
  META_PROPERTY: 'metaProperty',
};

const TabMetaPropertyMapping = {
  [K8_NAVTABS.K8M_DEP_TAB]: 'metaProperty1',
  [K8_NAVTABS.K8M_STAT_TAB]: 'metaProperty1',
  [K8_NAVTABS.K8M_DAEMON_TAB]: 'metaProperty1',
  [K8_NAVTABS.K8M_POD_TAB]: 'metaProperty1',
};

const TagsMapping = {
  [K8_NAVTABS.K8M_NODE_TAB]: K8NodesTags,
  [K8_NAVTABS.K8M_DEP_TAB]: K8DeploymentTags,
  [K8_NAVTABS.K8M_STAT_TAB]: K8DeploymentTags,
  [K8_NAVTABS.K8M_DAEMON_TAB]: K8DeploymentTags,
};

const DetailsMetricsMapping = {
  [K8_NAVTABS.K8M_NODE_TAB]: K8NodesMetrics,
  [K8_NAVTABS.K8M_DEP_TAB]: K8DeploymentMetrics,
  [K8_NAVTABS.K8M_STAT_TAB]: K8StatefulsetMetrics,
  [K8_NAVTABS.K8M_DAEMON_TAB]: K8DaemonsetMetrics,
};

const DeploymentStatus = {
  true: i18n.global.t('k8.available'),
  false: i18n.global.t('k8.unAvailable'),
  unknown: i18n.global.t('k8.unknown'),
};

const NamespaceStatus = {
  Active: i18n.global.t('k8.active'),
  Terminating: i18n.global.t('k8.terminating'),
};

const NodeSatus = {
  true: i18n.global.t('k8.ready'),
  false: i18n.global.t('k8.notReady'),
  unknown: i18n.global.t('k8.unknown'),
};

const PodScheduleStatus = {
  true: i18n.global.t('k8.scheduled'),
  false: i18n.global.t('k8.unScheduled'),
  unknown: i18n.global.t('k8.unknown'),
};

const PodTerminatedStatus = {
  0: i18n.global.t('k8.notTerminated'),
  1: i18n.global.t('k8.terminated'),
};

const PodStatus = {
  Pending: i18n.global.t('k8.pending'),
  Succeeded: i18n.global.t('k8.succeeded'),
  Failed: i18n.global.t('k8.failed'),
  Unknown: i18n.global.t('k8.unknown'),
  Running: i18n.global.t('k8.running'),
};

const InstanceStatusMapping = {
  K8S_NODE: NodeSatus,
  K8S_POD: PodStatus,
  K8S_NAMESPACE: NamespaceStatus,
  K8S_DEPLOYMENT: DeploymentStatus,
};

const InstanceTypeList = [
  'K8S_DEPLOYMENT',
  'K8S_NAMESPACE',
  'K8S_POD',
  'K8S_NODE',
];

const TooltipKeyMapping = ['K8S_NAMESPACE'];

const K8StatusMetrics = {
  [K8_NAVTABS.K8M_NODE_TAB]: 'k8s_node_v2_status',
  [K8_NAVTABS.K8M_DEP_TAB]: 'k8s_deployment_v2_status',
  [K8_NAVTABS.K8M_POD_TAB]: 'k8s_pods_v2_status_ready',
};

const AlertInstanceType = [
  {
    key: K8_NAVTABS.K8M_CLUSTER_TAB,
    label: 'cluster',
  },
  {
    key: K8_NAVTABS.K8M_NODE_TAB,
    label: 'node',
  },
  {
    key: K8_NAVTABS.K8M_DEP_TAB,
    label: 'deployment',
  },
  {
    key: K8_NAVTABS.K8M_DAEMON_TAB,
    label: 'daemonset',
  },
  {
    key: K8_NAVTABS.K8M_STAT_TAB,
    label: 'statefulset',
  },
  {
    key: K8_NAVTABS.K8M_POD_TAB,
    label: 'pod',
  },
  {
    key: K8_NAVTABS.K8M_NAMESPACE_TAB,
    label: 'namespace',
  },
];

const TagsColorMapping = {
  ACTIVE_LIST: ['Ready', 'Scheduled', 'Not terminated', 'True', '0'],
  INACTIVE_LIST: ['Terminated', 'Not ready', 'Not scheduled', 'False', '1'],
};
export {
  K8Routes,
  K8NodesTags,
  K8NodesMetrics,
  K8DeploymentTags,
  K8DeploymentMetrics,
  K8PodsMetrics,
  K8PodTags,
  K8RoutesConfig,
  K8BreadcrumbNames,
  HeaderKeyMapping,
  K8MutationType,
  WorkloadList,
  StatusType,
  CustomClassType,
  IconNames,
  WorkloadPlaceholderList,
  K8SetMutationType,
  K8SetCurrentMutationType,
  InstanceType,
  headerKeyType,
  InstanceTabMapping,
  TabMetaPropertyMapping,
  HideNamespaceList,
  TagsMapping,
  DetailsMetricsMapping,
  K8DaemonsetMetrics,
  K8StatefulsetMetrics,
  InstanceStatusMapping,
  InstanceTypeList,
  K8StatusMetrics,
  PodScheduleStatus,
  PodTerminatedStatus,
  WorkloadMapping,
  NodeSatus,
  AlertInstanceType,
  TagsColorMapping,
  TooltipKeyMapping,
};
